import React, { useEffect, useRef, useState, useCallback } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import _ from 'lodash';
import styled, { css } from 'styled-components';
import { FormGroup, ControlGroup, InputGroup, TextArea } from '@blueprintjs/core';
import { Button, ButtonGroup, Dialog, Icon, MenuItem } from '@blueprintjs/core';
import { HTMLSelect } from '@blueprintjs/core';
import { Popover2, Tooltip2 } from '@blueprintjs/popover2';
import { Select } from '@blueprintjs/select';
import { Alignment, Classes, IconSize, DrawerSize, Position, Colors, Intent } from '@blueprintjs/core';
import { IconNames } from '@blueprintjs/icons';
import NoTagPhoto from '$root/graphics/no-tag-photo.png';
import { useAuth } from '$root/contexts/auth';


export default function ShowTagHistoryDialog(props)
{
    const { isOpen, tagId, onClose } = props
    const { getProtectedResource, postFormDataProtected } = useAuth();

    const [ tagHistory, setTagHistory ] = useState([]);
    const [ tagLinks, setTagLinks ] = useState([]);
    const [ loadThumbnailCache, setLoadThumbnailCache ] = useState(false);
    const [ showPhoto, setShowPhoto ] = useState({
        show:false,
        url:null,
    });

    const thumbnailCache = useRef({});


    useEffect(() => {
        Promise
            .all([
                getProtectedResource(`/tag2.php?task=tag-history&tid=${tagId}`),
                getProtectedResource(`/tag2.php?task=tag-link&tid=${tagId}`),
            ])
            .then(([response, links]) => {
                setTagHistory(response.data.history);
                setTagLinks(links.data.tagLinks);
            })
            .catch((err) => {
                console.error(err)
            })

        return () => {
            _.forEach(thumbnailCache.current, (v, k) => {
                try {
                    URL.revokeObjectURL(v.url);
                }
                catch {}
            });
        }
    }, []);


    useEffect(() => {
        if (!_.isArray(tagHistory))
            return;

        for (let i = 0; i < tagHistory.length; i++) {
            if (_.has(thumbnailCache.current, tagHistory[i].history_id))
                continue;

            getProtectedResource(`/tag2.php?task=tag-photo-by-history&thid=${tagHistory[i].history_id}&thumbnail`, 'arraybuffer')
                .then(response => {
                    console.log('image', response)

                    const blob = new Blob([ response.data ]);
                    if (blob.size) {
                        const url = URL.createObjectURL(blob);

                        thumbnailCache.current[tagHistory[i].history_id] = {
                            valid:true,
                            url
                        };
                    }
                    else {
                        thumbnailCache.current[tagHistory[i].history_id] = {
                            valid:false,
                        };
                    }

                    setLoadThumbnailCache(old => !old);
                })
                .catch((err) => {
                    console.error(err)
                })
            ;
            break;
        }

    }, [tagHistory, loadThumbnailCache]);


    const onThumbnailClick = useCallback((hid) => {
        getProtectedResource(`/tag2.php?task=tag-photo-by-history&thid=${hid}`, 'arraybuffer')
            .then(response => {

                const blob = new Blob([ response.data ]);
                if (blob.size) {
                    const url = URL.createObjectURL(blob);

                    setShowPhoto({
                        show:true,
                        url
                    });
                }
            })
            .catch((err) => {
                console.error(err)
            })
        ;
    }, [setShowPhoto]);


    let caption = '';
    let title = '';
    let category = '';
    let discipline = '';
    let history;

    let attachments = (tagLinks || []).map(l => {
        return (<>
            <span style={{whiteSpace:"nowrap"}}>{l.link_context}</span>
            <div style={{}}>
                <a href={l.link} target={"_blank"}>{l.link}</a>
            </div>
            </>)
    });

    if (_.isArray(tagHistory) && tagHistory.length > 0) {
        caption = `${tagHistory[0].tag}`;
        title = `${tagHistory[0].title}`;
        category = `${tagHistory[0].category}`;
        discipline = `${tagHistory[0].discipline}`;

        history = tagHistory.map(entry => {
            let thumbnail;
            let hasImage = false;
            if (_.has(thumbnailCache.current, entry.history_id) &&
                thumbnailCache.current[entry.history_id].valid) {
                thumbnail = thumbnailCache.current[entry.history_id].url;
                hasImage = true;
            }

            return (
                <div key={entry.history_id}
                     style={{
                         // display: 'flex',
                         // flexDirection: 'row',
                         // gap:'4px',
                         display: 'grid',
                         gridTemplateColumns: `6em ${IconSize.LARGE}px 9em auto 180px`,
                         gridTemplateRows: 'auto',
                         gap: '4px 4px',
                         gridTemplateAreas: '. . . . .',
                     }}
                >
                    <div style={{}}>{entry.created_at_date}</div>
                    <Icon icon={IconNames.SYMBOL_SQUARE} size={IconSize.LARGE} color={entry.status_bgcolor} />
                    <div style={{}}>{entry.status}</div>
                    <div style={{}}>{entry.comment}</div>

                    {hasImage &&
                        <div style={{ width:128, height:80, borderRadius:4, }}>
                             <img src={thumbnail}
                                  style={{cursor:'pointer'}}
                                  onClick={() => onThumbnailClick(entry.history_id)}
                             />
                        </div>
                    }
                    {!hasImage &&
                        <div style={{ width:128, height:80, borderRadius:4, }}>
                            {/*<img src={NoTagPhoto} />*/}
                        </div>
                    }
                </div>
            );
        });
    }

    return (
        <>
            {!showPhoto.show &&
                <Dialog
                    title={`Címke: ${caption}`}
                    canEscapeKeyClose
                    canOutsideClickClose
                    isOpen={isOpen}
                    onClose={onClose}
                    style={{
                        minWidth:'50%',
                        minHeight:'50%',
                        maxHeight:'50vh',
                        zIndex:150
                    }}
                >
                    <div style={{ display:'flex', flexDirection:'column', padding:'1rem', }}>
                        <div style={{
                            display:'grid',
                            gridTemplateColumns:'10rem auto',
                            gridTemplateRows:'auto',
                            gap:'4px 4px',
                            gridTemplateAreas:'. .',
                        }}
                        >
                            <span>Megnevezés</span>
                            <div style={{}}>
                                {title}
                            </div>
                            <span>Kategória</span>
                            <div style={{}}>
                                {category}
                            </div>
                            <span>Szakág</span>
                            <div style={{}}>
                                {discipline}
                            </div>
                            {attachments}
                        </div>
                        <div style={{
                            marginTop:'1rem',
                            padding:'4px',
                            overflowY:'scroll',
                            display:'flex',
                            flexDirection:'column',
                            gap:'4px',
                            border:'1px solid lightgray',
                        }}>
                            {history}
                        </div>
                    </div>
                </Dialog>
            }
            {showPhoto.show &&
                <Dialog
                    title={`Tag: ${caption}`}
                    canEscapeKeyClose
                    canOutsideClickClose
                    isOpen={showPhoto.show}
                    onClose={() => { URL.revokeObjectURL(showPhoto.url); setShowPhoto({show:false, url:null}); }}
                    style={{
                        width:'90vw',
                        height:'90vh',
                        zIndex:150,
                    }}
                >
                    <div style={{
                        display:'absolute',
                        flexDirection:'column',
                        padding:'1rem',
                        backgroundImage: `url(${showPhoto.url})`,
                        backgroundRepeat: `no-repeat`,
                        backgroundPosition: `center`,
                        backgroundSize: `contain`,
                        width:'100%',
                        height:'100%',
                    }}>
                    </div>
                </Dialog>
            }
        </>
    );
}